<script>
  export default {
    name: "AppBigDiamonds",
    mounted() {
      const containers = document.querySelectorAll(".bigContainer");

      containers.forEach(container => {
        for (let i = 0; i < 9; i++) {
          const diamond = document.createElement("div");
          diamond.classList.add("bigDiamond");
          diamond.classList.add("layer3");

          // Positionnement aléatoire dans le conteneur
          diamond.style.left = `${(Math.floor(i/3)*30 + Math.random() * 30)+ 5}vw`;
          diamond.style.top = `${((i%3)*30 + Math.random() * 30)+ 5}vh`;

          if (Math.random()*9 > 1){
            container.appendChild(diamond);
          } else {
            if (Math.random()*2 > 1){
              container.appendChild(diamond);
              diamond.style.left = `${Math.random() * 100}vw`;
              diamond.style.top = `${Math.random() * 100}vh`;
              container.appendChild(diamond);
            }
          }
        }
      });
    }
  };
</script>

<template>
  <div class="bigContainer"></div>
</template>

<style>
  .bigContainer{
    position: absolute;
    pointer-events: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    clip-path: inset(0 0 0 0);
  }

  .bigDiamond {
    width: 32px;
    height: 32px;
    background-color: rgba(211, 211, 91, 0.3);
    position: fixed;
    transform: rotate(45deg); /* Transformation en losange */
    z-index: -1;
  }
</style>